import FloatingVue from 'floating-vue'

export default defineNuxtPlugin((nuxtApp) => {
  if (process.client) {
    nuxtApp.vueApp.use(FloatingVue)
  }
})